module.exports = __webpack_public_path__ + "battery.24294415.png";